import React from 'react'
import { Container, Box, Text, Image, Tooltip, Divider } from '@chakra-ui/react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import Login from '../components/authentication/Login'
import Signup from '../components/authentication/Signup'
import { useEffect } from 'react'
import { refreshPage } from '../config/ChatLogistics'
import { useHistory } from 'react-router-dom'
const Home = () => {

  const history = useHistory()

  useEffect(()=>{
    const user = JSON.parse(localStorage.getItem("userInfo"))
    if (user) history.push("/chats")
  },[history])

  return (
    <Container  centerContent>
    {/* <Container width={'60%'} minW={'400px'}   centerContent> */}
      <Box 
        display={'flex'}
        textAlign={"center"}
        justifyContent = {'center'}
        p= {3}
        bg ={'white'}
        w={"100%"}
        m={"0px 0px 15px 0px"}
        // border={'2px solid #868686'}
        borderRadius={'lg'}
        borderWidth={"1px"}
        borderRadius={'10px 10px 0px 0px'}
    boxShadow={"bxshd.mainComp"}
        // boxShadow={"bxshd.mainComp"}
        >
          <Tooltip
           label="click to refresh" 
            hasArrow 
            placement='bottom'
          >

          
          <Image
            m = 'auto'
            p = {2}
            boxSize='100%'
            width = 'auto'
            objectFit='cover'
            src='./assets/TinCan_Logo_03.png'
            alt='Tin-Can Logo'
            borderRadius={"20px"}

             onClick={()=>{refreshPage()}}
            cursor={'pointer'}
          boxShadow={"bxshd.inset_blk"}
          // className='can-gradient'
          />
          </Tooltip>
        {/* <Text m={'auto'} fontSize={'4xl'} fontFamily={'Gilroy Bold'} color={"black"}>TinCan</Text> */}
      </Box>
      <Box
        p={4}
        bg ={'white'}
        w="100%"
        // m="40px 0 15px 0"
        borderRadius={'0px 0px 10px 10px'}
        borderWidth={"1px"}
        boxShadow={"bxshd.mainComp"}
     
     >

    <Tabs variant={"soft-rounded"}>
      <TabList 
      mb='1em'
      justifyContent={'space-evenly'}>
        <Tab 
          width="40%" 
          boxShadow={"bxshd.homeBtn1"}
          borderRadius={'0px 5px 0px 5px'}
          border={'1px solid #868686'}
          color={'#868686'}
          borderBottom={'none'}
          borderRight={'none'}
          >Login</Tab>
          {/* <Divider orientation='vertical'borderColor={'#868686'}/> */}
        <Tab 
        width="40%"
        boxShadow={"bxshd.homeBtn2"}
        borderRadius={'5px 0px 5px 0px'}
        border={'1px solid #868686'}
        color={'#868686'}
        borderBottom={'none'}
        borderLeft={'none'}
        >Sign up</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
         <Login />
        </TabPanel>
        <TabPanel>
          <Signup />
        </TabPanel>
      </TabPanels>
    </Tabs>
      </Box>
    </Container>
    
  )
}

export default Home